import React from "react";
import PropTypes from "prop-types";
import { addDefaultImg } from "../../utils/common-methods";
function Avatar({
  imageUrl,
  altText,
  size,
  borderWidth,
  backgroundColor,
  borderColor,
}) {
  return (
    <div
      className="avatar"
      style={{
        width: size,
        height: size,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: borderWidth,
      }}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={altText}
          className="avatar-img"
          onError={addDefaultImg}
        />
      ) : (
        <div
          className="avatar-placeholder"
          style={{
            backgroundColor: backgroundColor,
            borderColor: borderColor,
          }}
        >
          {altText ? altText.charAt(0) + altText.charAt(1) : "?"}
        </div>
      )}
    </div>
  );
}

Avatar.propTypes = {
  imageUrl: PropTypes.string,
  altText: PropTypes.string,
  size: PropTypes.number, // Size of the Avatar
};

export default Avatar;
